<template>
    <div style="width:100%" class="mb-4">

        <v-expansion-panels>
            <v-expansion-panel>
                <v-expansion-panel-header>
                    Change History
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-data-table :headers="headers"
                                  :items="data"
                                  fixed-header
                                  item-class="d-flex justify-start"
                                  class="elevation-1">

                        <template v-slot:item.logged="{ item }">
                            {{ item.logged | DateTime }}
                        </template>

                        <template v-slot:item.affectedOperator="{}">
                            <v-chip class="ma-1" :key="operator" small v-for="operator in affectedOperatorArray" @click="onClickOperatorName(operator)">
                                {{ operator }}
                            </v-chip>
                        </template>

                    </v-data-table>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

    </div>
</template>

<script>

    export default {
        name: 'SevImpactLog',
        data: function () {
            return {
                headers: [
                    { text: 'Incident', value: 'incident' },
                    { text: 'Date', value: 'logged' },
                    { text: 'Customer Perspective', value: 'customerPerspective' },
                    { text: 'Root Cause', value: 'rootCause' },
                    { text: 'Affected Operator', value: 'affectedOperator' },
                    { text: 'Assigned Team', value: 'assignedTeam' },
                    { text: 'Bets', value: 'bets' },
                    { text: 'Registration', value: 'reg' },
                    { text: 'Login', value: 'login' },
                    { text: 'Banking', value: 'banking' },
                    { text: 'Other', value: 'other' },
                    { text: 'Other List', value: 'otherImpactList' },
                    { text: 'Comment', value: 'comment' },
                    { text: 'Assignee', value: 'assignee' },
                    { text: 'Sign Off', value: 'signOff' },
                    { text: 'Updater', value: 'updater' },
                ],
            }
        },
        components: {

        },
        props: {
            data: {
                default: () => [],
                type: Array
            },
        },
        computed: {
            affectedOperatorArray() {
                if (!this.data.affectedOperator) return [];
                return this.data.affectedOperator.replace("[", "").replace("]", "").replace(/"/g, "").split(',').filter(operator => operator !== "");
            }
        },
        methods: {

        }
    }
</script>
